import React from 'react';
import { getConcernSeverityTag, getConcernStatusTone } from '../../utils/reportSeverity';

const TONE_FILL = {
  focus: 'linear-gradient(90deg, #fb923c, #ea580c)',
  monitor: 'linear-gradient(90deg, #facc15, #ca8a04)',
  good: 'linear-gradient(90deg, #a78bfa, #6D28D9)',
  high: 'linear-gradient(90deg, #fb923c, #ea580c)',
  medium: 'linear-gradient(90deg, #facc15, #ca8a04)',
  low: 'linear-gradient(90deg, #a78bfa, #6D28D9)',
};

/** Horizontal concern score bars — severity first, severity-colored score slider. */
export default function SkinHealthScoresPanel({
  items = [],
  selectedName,
  selectedKey,
  onSelect,
  showTitle = false,
}) {
  const selected = selectedName || selectedKey || null;

  return (
    <div className="skin-report-health-panel">
      {showTitle ? <h2 className="skin-report-section-title">Skin Health Scores</h2> : null}
      <div className="skin-report-health-list" role="list">
        {items.length === 0 ? (
          <p className="skin-report-empty">No significant concerns detected.</p>
        ) : (
          items.map((item) => {
            const score = Math.max(0, Math.min(100, Number(item.score || 0)));
            const isSelected = selected === item.class_name;
            const tone = getConcernStatusTone(score);
            const severity = getConcernSeverityTag(score);
            const fill = TONE_FILL[tone] || TONE_FILL.good;
            return (
              <button
                key={item.class_name}
                type="button"
                role="listitem"
                className={`skin-report-health-row${isSelected ? ' is-selected' : ''} skin-report-health-row--${tone}`}
                onClick={() => onSelect?.(item.class_name)}
              >
                <span className={`skin-report-health-severity skin-report-health-severity--${severity.tone}`}>
                  {severity.label}
                </span>
                <span className="skin-report-health-name">{item.label}</span>
                <span className="skin-report-health-bar-wrap" aria-hidden="true">
                  <span
                    className="skin-report-health-bar-fill"
                    style={{
                      width: `${score}%`,
                      backgroundImage: fill,
                      backgroundColor: severity.tone === 'high'
                        ? '#ea580c'
                        : severity.tone === 'medium'
                          ? '#ca8a04'
                          : '#6D28D9',
                    }}
                  />
                </span>
                <span className="skin-report-health-score">
                  {Math.round(score)}/100
                </span>
              </button>
            );
          })
        )}
      </div>
    </div>
  );
}
